import type { Metadata } from "next"

const URL = "http://www.ie-kachi.or.jp"
const TITLE = "日本の住宅に、もっと安心と価値向上を。"
const APP_NAME = "住宅資産管理センター"
const DESCRIPTION = ""

export const SEO: Metadata = {
  applicationName: APP_NAME,
  description: DESCRIPTION,
  openGraph: {
    type: "website",
    description: DESCRIPTION,
    images: [
      {
        alt: DESCRIPTION,
        height: 630,
        url: `${URL}/og.png`,
        width: 1200,
      },
    ],
    locale: "ja_JP",
    siteName: `${TITLE} | ${APP_NAME}`,
    title: APP_NAME,
    url: URL,
  },
  title: { default: TITLE, template: `%s | ${APP_NAME}` },
}
